module.exports = {
  dimensions: {
    width: 14,
    height: 14
  },
  optical: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
};